
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BackupDto } from '@/services/Backup/interfaces/index';

@Component
export default class DeleteBackupDialog extends Vue {
  @Prop()
  public readonly backup!: BackupDto;
  @Prop()
  public readonly onDelete!: CallableFunction;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove Backup: ${this.backup.id}?`;
  }

  public async deleteBackup(): Promise<void> {
    this.$emit('delete', this.backup);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
